import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from '../components/layout/Header/Header';
import Footer from '../components/layout/Footer/Footer';
import ProtectedRoute from '../components/ProtectedRoute';
// 懒加载组件
const RankingDetailPage = React.lazy(() => import('../pages/RankingDetailPage'));
const NotFoundPage = React.lazy(() => import('../pages/NotFoundPage'));
const RankingsPage = React.lazy(() => import('../pages/RankingsPage'));
const ProductList = React.lazy(() => import('../pages/product/ProductList'));
const ProductItem = React.lazy(() => import('../pages/product/ProductItem'));
const CreateProduct = React.lazy(() => import('../pages/product/CreateProduct'));
const Login = React.lazy(() => import('../features/member/Login'));
const Register = React.lazy(() => import('../features/member/Register'));

const AppRoutes: React.FC = () => {
  return (
    <div className="app-layout">
      <Header />
      <main className="main-content">
        <Suspense>
          <Routes>
            {/* 受保护的路由 - 放在前面避免路由冲突 */}
            <Route path="/product/create" element={
              <ProtectedRoute>
                <CreateProduct />
              </ProtectedRoute>
            } />
            <Route path="/create-product" element={
              <ProtectedRoute>
                <CreateProduct />
              </ProtectedRoute>
            } />
            
            {/* 公开路由 */}
            <Route path="/" element={<ProductList />} />
            <Route path="/product/:id" element={<ProductItem />} />
            <Route path="/rankingList" element={<RankingsPage />} />
            <Route path="/ranking/:id" element={<RankingDetailPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default AppRoutes; 